// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-of {
    white-space: nowrap;
}
.page-of{
    color:var(--color-text-dark);
    font-weight: 700;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif; 
}
.page-of .page-link {
    padding: 0.25rem 0.75rem;
}
.pagination .page-item .page-link{
    border:none;
}
.page-link{
    color:#000 !important;
    background-color: transparent !important;
}
.result-count {
    font-weight: 700;
    color: var(--color-text-dark);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
    padding: 0.25rem 0.75rem;
}
.paging{
    color:var(--color-text-dark);
    font-weight: 700;
    font-family: "agGridAlpine";
    font-size: 16px;
    line-height: 16px;
    font-style: normal;
    font-weight: normal;
    font-feature-settings: normal;
    font-variant: normal;
    text-transform: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.paging.next *::before {
    content: "\\f11f";
    font-size: 1.25rem;
    font-weight: bolder;
}
.paging.last *::before{
    content: "\\f118";
    font-size: 1.5rem;
    font-weight: bolder;
}
.paging.first *::before{
    content: "\\f115";
    font-size: 1.5rem;
    font-weight: bolder;
}
.paging.previous *::before{
    content: "\\f125";
    font-size: 1.25rem;
    font-weight: bolder;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/TablePaging.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;AACA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,gIAAgI;AACpI;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,WAAW;AACf;AACA;IACI,qBAAqB;IACrB,wCAAwC;AAC5C;AACA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,gIAAgI;IAChI,wBAAwB;AAC5B;AACA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,oBAAoB;IACpB,oBAAoB;IACpB,mCAAmC;IACnC,kCAAkC;AACtC;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB","sourcesContent":[".page-of {\r\n    white-space: nowrap;\r\n}\r\n.page-of{\r\n    color:var(--color-text-dark);\r\n    font-weight: 700;\r\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif; \r\n}\r\n.page-of .page-link {\r\n    padding: 0.25rem 0.75rem;\r\n}\r\n.pagination .page-item .page-link{\r\n    border:none;\r\n}\r\n.page-link{\r\n    color:#000 !important;\r\n    background-color: transparent !important;\r\n}\r\n.result-count {\r\n    font-weight: 700;\r\n    color: var(--color-text-dark);\r\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\r\n    padding: 0.25rem 0.75rem;\r\n}\r\n.paging{\r\n    color:var(--color-text-dark);\r\n    font-weight: 700;\r\n    font-family: \"agGridAlpine\";\r\n    font-size: 16px;\r\n    line-height: 16px;\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    font-feature-settings: normal;\r\n    font-variant: normal;\r\n    text-transform: none;\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n}\r\n.paging.next *::before {\r\n    content: \"\\f11f\";\r\n    font-size: 1.25rem;\r\n    font-weight: bolder;\r\n}\r\n.paging.last *::before{\r\n    content: \"\\f118\";\r\n    font-size: 1.5rem;\r\n    font-weight: bolder;\r\n}\r\n.paging.first *::before{\r\n    content: \"\\f115\";\r\n    font-size: 1.5rem;\r\n    font-weight: bolder;\r\n}\r\n.paging.previous *::before{\r\n    content: \"\\f125\";\r\n    font-size: 1.25rem;\r\n    font-weight: bolder;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
